import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ed2bb73"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "payment_explanation_modal_wrapper" }
const _hoisted_2 = { class: "payment_explanation_modal_body" }
const _hoisted_3 = { class: "payment_explanation_modal_title" }
const _hoisted_4 = { class: "payment_explanation_modal_content" }
const _hoisted_5 = {
  key: 0,
  class: "payment_explanation_modal_loading"
}
const _hoisted_6 = { class: "payment_explanation_modal_buttons_wrapper" }

export function render(_ctx, _cache) {
  const _component_paymentExplanation = _resolveComponent("paymentExplanation")
  const _directive_click_outside = _resolveDirective("click-outside")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('order.explanation.header')), 1),
      _createElementVNode("div", _hoisted_4, [
        (!_ctx.isLoaded)
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.$t('datatable.load')), 1))
          : _createCommentVNode("", true),
        (_ctx.isLoaded && _ctx.order?.explanation)
          ? (_openBlock(), _createBlock(_component_paymentExplanation, {
              key: 1,
              explanation: _ctx.order.explanation,
              currencySign: _ctx.order.currencySign
            }, null, 8, ["explanation", "currencySign"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          class: "primary_button",
          onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.close && _ctx.close(...args)))
        }, _toDisplayString(_ctx.$t('order.explanation.close')), 1)
      ])
    ])), [
      [_directive_click_outside, _ctx.close]
    ])
  ]))
}